import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Grid, TypographyProps, Stack, Button } from '@mui/material';
import moment from 'moment';

import { TP_COLORS } from '../../../../constants';
import { IQuiz } from '../../../../store/QuizSlice';
import { getSubjectColor } from '../../../../helper';
import DetailViewCard from '../../../../components/Card/DetailViewCard';

interface QuizListItemProps {
  quiz: IQuiz;
}

// STYLES
const titleProps: TypographyProps = {
  variant: 'caption',
  className: 'ellipsis-text',
  sx: {
    color: 'text.primary',
  },
};
const descriptionProps: TypographyProps = {
  className: 'ellipsis-text',
  variant: 'subtitle2',
  fontWeight: 600,
  sx: {
    color: 'text.primary',
  },
};

const QuizListItem: React.FC<QuizListItemProps> = ({ quiz }) => {
  // HOOKS
  const navigate = useNavigate();

  const quizSubTopics =
    quiz && quiz.subTopics && quiz.subTopics.length ? quiz.subTopics : [];

  let subTopicText = '';

  quizSubTopics.forEach((quizSubTopic, index) => {
    const subTopicName = quizSubTopic.subTopic?.name || '';

    if (!subTopicText.includes(subTopicName)) {
      if (index > 0) {
        subTopicText += ', ';
      }

      subTopicText += subTopicName;
    }
  });

  return (
    <Card elevation={3} sx={{ mb: '15px' }}>
      <div style={{ padding: '15px' }}>
        <Grid container alignItems="center" spacing={2}>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <DetailViewCard
              title="Topic"
              description={quiz.topic.name || '-'}
              titleProps={titleProps}
              descriptionProps={descriptionProps}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2}>
            <DetailViewCard
              title="Sub Topics"
              description={subTopicText}
              titleProps={titleProps}
              descriptionProps={{
                ...descriptionProps,
                title: subTopicText,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2}>
            <DetailViewCard
              title="Curriculum"
              description={quiz.topic.curriculum || '-'}
              titleProps={titleProps}
              descriptionProps={descriptionProps}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2}>
            <DetailViewCard
              title="Subject"
              description={quiz.topic.subject || '-'}
              titleProps={{
                ...titleProps,
                style: { color: TP_COLORS.white },
              }}
              descriptionProps={{
                ...descriptionProps,
                style: { color: TP_COLORS.white },
              }}
              containerProps={{
                sx: {
                  background: getSubjectColor(quiz.topic.subject),
                },
              }}
            />
          </Grid>
          <Grid item xs={12} sm={10} md={6} lg={2}>
            <DetailViewCard
              title="Last Updated At"
              description={
                quiz.updatedAt
                  ? moment(quiz.updatedAt).format('YYYY-MM-DD hh:mm A')
                  : '-'
              }
              titleProps={titleProps}
              descriptionProps={descriptionProps}
            />
          </Grid>
          <Grid item xs={12} sm={2} md={2} lg={1}>
            <Stack direction="row" justifyContent="center" alignItems="center">
              <Button
                size="small"
                variant="contained"
                color="inherit"
                onClick={() => {
                  navigate(
                    `${process.env.PUBLIC_URL}/dashboard/quiz-history/submissions/${quiz._id}`
                  );
                }}
                style={{ color: TP_COLORS.black }}
              >
                View
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </div>
    </Card>
  );
};

export default QuizListItem;
